import React from "react";

function Family() {
  window.scrollTo(0, 0);
  return (
    <div>
     
<section className="ftco-section" style={{padding:"0px"}}>
    <div className="container">
      <div className="row mb-5  mx-auto">
        <div className="heading-section ftco-animate fadeInUp ftco-animated">
        <h2 style={{color:"#3A3A3A"}}><b>Family</b></h2>
            <div style={{color:"#5E5550"}}>
              <p>
              Family matters are mainly Shariah focused in the Kingdom of Bahrain.  We provide services ranging from family matters relating to marriage, divorce, trust, inheritance and intestacy laws.
              </p>
              <p>
              All family matters even those escalating to cover a criminal law aspect are dealt with by the firm.
              </p>
              <p>
              We have represented clients wishing to end their marital relationship, on the other hand our services can go as far as resolving disputes regarding inheritance. 
              </p>
            </div>
        </div>
      </div>
    </div>
  </section>
</div>
  );
}

export default Family;
